import { render, staticRenderFns } from "./mbrInfo.vue?vue&type=template&id=27ea7382&scoped=true"
import script from "./mbrInfo.vue?vue&type=script&lang=js"
export * from "./mbrInfo.vue?vue&type=script&lang=js"
import style0 from "./mbrInfo.vue?vue&type=style&index=0&id=27ea7382&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ea7382",
  null
  
)

export default component.exports